module.exports = __webpack_public_path__ + "static/img/s33.ac37a12d.png";